import { render, staticRenderFns } from "./vFormAUDIO.vue?vue&type=template&id=0f9dc1b8&"
import script from "./vFormAUDIO.vue?vue&type=script&lang=js&"
export * from "./vFormAUDIO.vue?vue&type=script&lang=js&"
import style0 from "./vFormAUDIO.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports